module.exports = __webpack_public_path__ + "static/media/brick-up.ebefa254.jpg";